import MaterialTable from "@material-table/core";
import React, {useContext, useMemo, useRef, useState} from "react";
import {getColumns, LOCALIZATION, OPTIONS} from "./params";
import {QuotationSchema, QuotationsTableProps} from "../types";
import AuthenticationService from "@services/AuthenticationService";
import Modal from "@ui-components/Modal";
import {FormattedMessage, useIntl} from "react-intl";
import TableStyle from "@components/TableStyle";
import {tableIcons} from "@ui-components/TableIcons";
import CountryContext from "../../../CountryContext";

export const QuotationsTable = ({
  onFetch,
  onDelete,
  loading,
  ...rest
}: QuotationsTableProps) => {

  // context
  const {country: {code}} = useContext(CountryContext)

  // hooks
  const intl = useIntl();

  // state
  const [selectedId, setSelectedId] = useState<number>();
  // utilities
  const { id: user_id, user_type } = AuthenticationService.getUserData();
  const userScopes = AuthenticationService.getUserScopes();
  const params: [string, number, string, (id: number) => void, string[], any]
    = [code, user_id, user_type, setSelectedId, userScopes, intl];

  // refs
  const tableRef = useRef<MaterialTable<QuotationSchema>>();

  // utilities
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns =useMemo(
    () => getColumns(...params),
    [code, user_id, user_type, setSelectedId, intl]
  );  // avoid filters reset on rerender
  const refresh = () => {
    // @ts-ignore
    tableRef.current?.onQueryChange(undefined);
  };

  return <>
    <TableStyle>
      <MaterialTable<QuotationSchema>
        tableRef={tableRef}
        columns={columns}
        data={(query) => onFetch(query, columns)}
        isLoading={loading}
        options={OPTIONS}
        localization={LOCALIZATION}
        icons={tableIcons}
        {...rest}
      />
    </TableStyle>
    {!!selectedId && (
      <Modal
        type="error"
        title={<FormattedMessage id={"delete_quotation_title"}/>}
        description={<FormattedMessage id={"delete_quotation_description"}/>}
        onConfirm={async () => {
          await onDelete(selectedId);
          refresh();
          setSelectedId(undefined);
        }}
        onExit={() => setSelectedId(undefined)}
        onDismiss={() => setSelectedId(undefined)}
        confirmText={intl.formatMessage({id: "confirm"}).toUpperCase()}
        dismissText={intl.formatMessage({id: "cancel"}).toUpperCase()}
        children={undefined}
      />
    )}
  </>
}